import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./App";
import { NavBar } from "./components/NavBar";
import { useDarkMode } from "./hooks/useDarkMode";

export const Layout = () => {
  let auth = useAuth();
  const { isDark, toggle } = useDarkMode();

  // redirect to login if not logged in
  let navigate = useNavigate();
  if (false) {
    // if (!auth.user) {
    navigate("/login");
  }
  return (
    <div className="bg-gray-100 dark:bg-gray-900 h-full overflow-auto transition-colors">
      <NavBar
        isLoggedIn={auth.user?.jwt ? true : false}
        logout={() => {
          auth.signout();
        }}
        isDark={isDark}
        toggleDark={toggle}
      />
      <div className="px-10 pb-16">
        <Outlet />
      </div>
    </div>
  );
};
